(ns com.oly.static-sites.portfolio.core
  (:require [dumdom.core :as dumdom]
            [com.oly.static-sites.portfolio.page :as c]))

(defn launch
  "Site entry point"
  []
  (dumdom/render
   [:div.bg-slate-200.w-full
    [:div.w-full.p-4.m-auto {:class "lg:w-4/5 lg:p-0"}
     (c/page-header)
     (c/dual-column-circle)
     (c/split-bar)
     (c/page-footer)]]
   (js/document.getElementById "app")))

